var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "form-group tex-center d-flex align-items-center flex-column",
    },
    [
      _c("input", {
        ref: "file",
        staticClass: "form-control",
        staticStyle: { display: "none" },
        attrs: { type: "file" },
        on: {
          change: function ($event) {
            return _vm.onChange($event)
          },
        },
      }),
      _vm._v(" "),
      _c("big-image-component", {
        attrs: {
          url:
            this.imageURL == null
              ? "https://selectum-cruise-images.s3.eu-central-1.amazonaws.com/web-images/image-uploader-default-image.jpeg"
              : this.imageURL,
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-sm",
          staticStyle: { "margin-top": "10px" },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$refs.file.click()
            },
          },
        },
        [_vm._v("Choose an image")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }